
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, Play } from "lucide-react";

const HeroSection = () => {
  return (
    <section id="accueil" className="relative overflow-hidden bg-navy py-16 text-primary-foreground md:py-24">
      <div className="container relative z-10 px-6 text-center">
        <div className="mx-auto max-w-5xl">
          <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-primary-foreground/20 bg-primary-foreground/10 px-4 py-2 text-sm font-medium">
            <CheckCircle2 className="h-4 w-4 text-brand-pink-light" />
            Un nouveau départ dans un cadre structuré et humain
          </div>
          <h1 className="mx-auto max-w-4xl text-4xl font-bold leading-tight md:text-5xl">
            Devenez recruteur indépendant <span className="text-brand-pink-light">chez Work&You</span>
          </h1>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-7 text-primary-foreground/85">
            Vous êtes en reconversion professionnelle ? Entreprenez dans le recrutement avec la liberté d'un indépendant, une méthode éprouvée et un collectif à vos côtés.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button 
              size="lg" 
              className="h-14 w-full max-w-[280px] text-base shadow-brand md:w-[280px]"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Démarrer mon projet
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="h-14 w-full max-w-[280px] border-primary-foreground/50 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground md:w-[280px]"
              onClick={() => document.getElementById('video-presentation')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <Play className="mr-1 h-4 w-4" /> Découvrir Work&You
            </Button>
          </div>

          <div className="mx-auto mt-14 max-w-4xl overflow-hidden rounded-lg border border-primary-foreground/15 bg-primary-foreground/5 p-2 shadow-brand">
            <img src="/lovable-uploads/hero-team.jpg" alt="Équipe Work&You en réunion collaborative" className="aspect-[16/7] w-full rounded-md object-cover" loading="eager" decoding="async" width="1087" height="720" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
